module.exports = __webpack_public_path__ + "static/media/bootstrap.9c0da4ae.svg";